import React from 'react';
import { VectorWithStars } from '@components/main-components/media/illustrations/VectorWithStars';

export const EmptyUserStat = ({ header, subText }: { header: string; subText: string }) => {
  return (
    <div className="-mt-2 flex h-full w-full flex-col items-center justify-center">
      <VectorWithStars />
      <div className="mt-6 flex flex-col items-center gap-4 text-center">
        <h3 className="max-w-[300px] font-title text-title-m font-medium">{header}</h3>
        <div className="max-w-[271px] font-base  text-base-l text-neutral400">{subText}</div>
      </div>
    </div>
  );
};
